export enum DataType {
  Task = 'task',
  Goal = 'goal',
  LifeArea = 'life-area',
  NewTask = 'new-task',
}

export enum InteractionType {
  Task = 'task',
  Goal = 'goal',
}
